export const parseAddressComponents = (addressComponent, typeToReturn) => {
    try {
        const streetNumber =
            (addressComponent.filter(c => c.types.includes('street_number'))[0] || [])
                .short_name || '';
        const streetName =
            (addressComponent.filter(c => c.types.includes('route'))[0] || [])
                .short_name || '';
        const city =
            (addressComponent.filter(c => c.types.includes('locality'))[0] || [])
                .long_name ||
            (addressComponent.filter(c => c.types.includes('postal_town'))[0] || [])
                .long_name ||
            (addressComponent.filter(c => c.types.includes('sublocality_level_1'))[0] || []) //eslint-disable-line
                .long_name; //eslint-disable-line
        const county = (
            addressComponent.filter(c =>
                c.types.includes('administrative_area_level_2')
            )[0] || []
        ).long_name;
        const regionLong = (
            addressComponent.filter(c =>
                c.types.includes('administrative_area_level_1')
            )[0] || []
        ).long_name;
        const regionShort = (
            addressComponent.filter(c =>
                c.types.includes('administrative_area_level_1')
            )[0] || []
        ).short_name;
        const country =
            (addressComponent.filter(c => c.types.includes('country'))[0] || [])
                .short_name || '';
        const postalCode =
            (addressComponent.filter(c => c.types.includes('postal_code'))[0] || [])
                .long_name || '';

        if (typeToReturn === 'object') {
            return {
                address: `${streetNumber} ${streetName}`,
                homeCity: city,
                stateId: `${regionShort}`,
                postalCode,
                country,
                county
            };
        } else {
            return (`${streetNumber} ${streetName} ${city} ${city === regionLong ? '' : regionLong} ${country} ${postalCode}`); //eslint-disable-line
        }
    } catch (err) {
        console.error(err);
    }
};
